var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{on:{"login":_vm.login,"login-external":_vm.loginExternal}})
}
var staticRenderFns = []

export { render, staticRenderFns }